import React from 'react'
import centrePaneOverlayAnchorElementState from './_centrePaneOverlayAnchorElementState'

const setCentrePaneOverlayElementState =
  (element = typeof window !== 'undefined' ? window.document.body : null) => centrePaneOverlayAnchorElementState.set(element)

const CentrePaneOverlayAnchor = () => <div ref={setCentrePaneOverlayElementState} />

export default CentrePaneOverlayAnchor
